import { createContext } from 'react';
import { translate, type Translate } from './i18n';
import type { Locale } from './types';

export interface I18nValue {
  locale: Locale;
  localeTag: string;
  t: Translate;
}

export const I18nContext = createContext<I18nValue>({
  locale: 'EN',
  localeTag: 'en',
  t: translate('EN'),
});
